
import TableList from "@components/templates/tablelist";
import { HttpShipManageList, HttpSubmitShipBill } from "@/service/billing";
import { HttpGetbillPeriodList } from "@/service/newbigaccount";
import { mapGetters } from "vuex";
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            peroList:[],
        };
    },
    created(){
        HttpGetbillPeriodList({
            page:1,
            rows:10000,
        }).then(res=>{
            this.peroList = res.data.content
        })
    },
    methods: {
        ajaxRequest: HttpShipManageList,
        interceptRequest(params) {
            const { EQ_billingDate } = params.search;
            params.search.LE_startTime = EQ_billingDate;
            params.search.GE_endTime = EQ_billingDate;
            delete params.search.EQ_billingDate;
            this.formData = params
            return params
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/billing/billDelivery/exportByManage', this.formData, {
                        executor: 'request',
                        download: true,
                        method: 'post',
                    })
                    break;
                case 'confirm':
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { ids: params },
                        title: this.$t('fbb.billDelivery.confirm',{defaultValue:'账单确认'}),
                        desc: this.$t('fbb.bill.confirmed_the_bill',{defaultValue:'是否确认账单，确认后账单不可更改'}),
                        ajaxRequest: HttpSubmitShipBill
                    };
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getNextOrgList']),
        ToolsData() {
            return [
                // {
                //     name: this.$t('fbb.billDelivery.confirm',{defaultValue:'账单确认'}),
                //     operate: "confirm",
                //     theme: "primary",
                //     batch: true,
                // },
                {
                    name: this.$t('global.common.export',{defaultValue:'导出'}),
                    operate: "export",
                    theme: "info",
                    // batch: true,
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.alloment.client_organization',{defaultValue:'客户'}),
                    tag: 'vSelect',
                    key: 'EQ_organizationId',
                    options:this.getNextOrgList,
                    show: true,
                    props:{
                        filterable:true,
                        clearable:true,
                    }
                },
                {
                    label: this.$t('fbb.billmanage.bill_no',{defaultValue:'账单编号'}),
                    tag: 'vInput',
                    key: 'EQ_billNo',
                    show: true,
                },
                {
                    label: this.$t('global.common.status',{defaultValue:'状态'}),
                    tag: 'vSelect',
                    key: 'EQ_status',
                    options:[
                        {value:0, label: this.$t('fbb.alloment.confirm',{defaultValue: "待确认"})},
                        {value:1, label:this.$t('global.common.confirmed',{defaultValue:'已确认'})},
                    ],
                    show: true,
                },

                {
                    label: this.$t('erp.b2border.payment_days',{defaultValue:'账期'}),
                    tag: 'vSelect',
                    key: 'EQ_periodId',
                    options: this.peroList.map(item=>{
                        return {
                            label:item.code,
                            value:item.id
                        }
                    }),
                    props:{
                        filterable:true,
                    },
                },
                {
                    label: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                },
            ]
        },
        columns() {
            return [
                {
                    show:false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: this.$t('global.common.cusorg',{defaultValue:'客户组织'}),
                    key: 'organizationId',
                    render: (h, { row }) => this.findRenderLabel(this.getNextOrgList, row.organizationId)
                },
                {
                    title: this.$t('fbb.billmanage.bill_no',{defaultValue:'账单编号'}),
                    key: 'billNo',
                },
                {
                    title: this.$t('global.common.status',{defaultValue:'状态'}),
                    key: 'status',
                    render: (h, {row}) => {
                        return <div>{row.status == 0 ? this.$t('fbb.alloment.confirm',{defaultValue: "待确认"}) : this.$t('global.common.confirmed',{defaultValue:'已确认'})}</div>
                    }
                },

                {
                    title: this.$t('erp.b2border.payment_days',{defaultValue:'账期'}),
                    render: (h,{row})=>{
                        return <div>
                            <div v-show={row.periodCode}>{row.periodCode} ({row.startTime} ~ {row.endTime})</div>
                            <div v-show={!row.periodCode}>--</div>
                        </div>
                    }
                },
                {
                    title: this.$t('fbb.delivery.totalCost',{defaultValue:'账单总额'})+'(USD)',
                    key: 'totalCost',
                },
                {
                    title: this.$t('fbb.bill.confirmation_time_person',{defaultValue:'确认人/确认时间'}),
                    render: (h,{row})=>{
                        return <div>
                            <div>{ row.confirmUser || '--' }</div>
                            <div>{ row.confirmAt || '--' }</div>
                        </div>
                    }
                },
                {
                    title: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
                    key: 'createdAt',
                },
                {
                    title: this.$t('global.common.updatedAt',{defaultValue:'更新时间'}),
                    key: 'updatedAt',
                },
            ];
        },

    },

};
